import { Button, Modal } from "react-bootstrap";

const OrderItemDescriptionModal = ({ name, show, setShow, description, item }) => {
    return (
        <Modal size="lg" className="fade" show={show}>
            <Modal.Header>
                <Modal.Title>{name}</Modal.Title>
                <Button
                    variant=""
                    className="btn-close"
                    onClick={() => setShow?.(false)}
                >
                </Button>
            </Modal.Header>
            <Modal.Body>
                <label htmlFor="" className="text-primary fw-bold">Descripción</label>
                <p>
                    {description || 'Sin descripción'}
                </p>

                {item?.feeForFormulating && (
                    <div className="mt-4 p-3 border rounded bg-light">
                        <h6 className="text-primary fw-bold mb-3">Información de Cobro por Formular</h6>
                        <div className="row">
                            <div className="col-md-4 mb-2">
                                <b>Autorizado por:</b>
                                <div>{item?.authorizedBy || '--'}</div>
                            </div>
                            <div className="col-md-4 mb-2">
                                <b>Cuenta:</b>
                                <div>{item?.account || '--'}</div>
                            </div>
                            <div className="col-md-4 mb-2">
                                <b>Cebe:</b>
                                <div>{item?.seven || '--'}</div>
                            </div>
                        </div>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    )
}

export default OrderItemDescriptionModal;